var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrazyZap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.615 1.59486C14.7614 1.67635 14.8763 1.80454 14.9414 1.95896C15.0065 2.11338 15.018 2.28515 14.974 2.44686L12.982 9.74986H20.25C20.3962 9.74987 20.5391 9.79258 20.6614 9.87276C20.7836 9.95293 20.8797 10.0671 20.9379 10.2011C20.9961 10.3352 21.0139 10.4834 20.989 10.6274C20.9642 10.7714 20.8978 10.9051 20.798 11.0119L10.298 22.2619C10.1837 22.3847 10.0314 22.4656 9.86564 22.4916C9.69987 22.5177 9.53015 22.4874 9.38363 22.4056C9.23711 22.3238 9.12224 22.1952 9.05741 22.0405C8.99258 21.8857 8.98152 21.7137 9.02601 21.5519L11.018 14.2499H3.75001C3.60385 14.2498 3.46088 14.2071 3.33867 14.127C3.21646 14.0468 3.12034 13.9327 3.06212 13.7986C3.0039 13.6645 2.98613 13.5164 3.01098 13.3723C3.03584 13.2283 3.10223 13.0947 3.20201 12.9879L13.702 1.73786C13.8164 1.6155 13.9684 1.53495 14.1339 1.50903C14.2993 1.48312 14.4687 1.51333 14.615 1.59486Z",
    fill: "#E6261F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrazyZap);
export default __webpack_public_path__ + "static/media/crazy_zap.5d9680dde7ddf3449b7386dbbe1aa044.svg";
export { ForwardRef as ReactComponent };